import { render, staticRenderFns } from "./NumberComponent.vue?vue&type=template&id=182df607&"
import script from "./NumberComponent.vue?vue&type=script&lang=js&"
export * from "./NumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports